import { CatchNotFound, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { NotFoundPage } from '@features/auth/pages/NotFoundPage';
import { isChessRussianClub } from '@features/chessrussian/customizations/utils/isChessRussianClub';
import { ClubCardPage } from '@features/club/pages/ClubCardPage';
import { useClubCard } from '@features/club/pages/ClubCardPage/useClubCard';
import { ClubEventSectionsWidget } from '@features/club/ui/ClubEventSections/ClubEventSectionsWidget';
import { ClubMyStatsWidget } from '@features/club/ui/ClubMyStats/ClubMyStatsWidget';
import { ClubParticipantsWidget } from '@features/club/ui/ClubParticipants/ClubParticipantsWidget';
import { ClubParticipationButtonWidget } from '@features/club/ui/ClubParticipationButton/ClubParticipationButtonWidget';
import { getClubMeta } from '@features/club/utils/club-meta';
import { LeadersClubWidget } from '@features/landing/grandprix/ui/components/LeadersClub';
import { SiteLayoutWidget } from '@features/shared/ui/SiteLayout/SiteLayoutWidget';

// Вкладки разделов событий: ?<section>=<tab>&<section>Sub=<subTab>
const querySchema = z.record(z.string(), z.unknown());

export const Route = createFileRoute('/club/$clubId')({
  component: () => (
    <CatchNotFound fallback={() => <NotFoundPage subTitle="Клуб не найден" />}>
      <Page />
    </CatchNotFound>
  ),
  validateSearch: querySchema,
});

function Page() {
  const { clubId } = Route.useParams();
  const search = Route.useSearch();
  const props = useClubCard({ clubId });
  const { eventSections } = getClubMeta(clubId);

  return (
    <SiteLayoutWidget clubId={clubId}>
      <ClubCardPage
        {...props}
        events={(className) => (
          <ClubEventSectionsWidget
            className={className}
            clubId={clubId}
            sections={eventSections}
            search={search}
            slots={isChessRussianClub(clubId) ? { grandprix: <LeadersClubWidget /> } : undefined}
          />
        )}
        members={<ClubParticipantsWidget clubId={clubId} />}
        myStats={<ClubMyStatsWidget clubId={clubId} />}
        participationButton={<ClubParticipationButtonWidget clubId={clubId} />}
      />
    </SiteLayoutWidget>
  );
}
